<template>
  <div class="tw:flex tw:gap-2 tw:px-4">
    <AITag
      :active="['all', 'influencer'].includes(contactType || '')"
      data-testid="journalist-tag"
      :disabled="loading"
      :label="getLocaleText('global.journalists')"
      @click="updateSearchTab('influencer')"
    />
    <AITag
      :active="['all', 'outlet'].includes(contactType || '')"
      data-testid="outlet-tag"
      :disabled="loading"
      :label="getLocaleText('global.outlets')"
      @click="updateSearchTab('outlet')"
    />
  </div>
</template>

<script setup lang="ts">
import { getLocaleText } from "shared/boot/i18n";
import AITag from "shared/components/AI/AITag.vue";
import { type SuggestedContactType } from "shared/composables/useSuggestedContacts";

interface AISuggestedContactsTagsProps {
  loading?: boolean;
}

const { loading } = defineProps<AISuggestedContactsTagsProps>();

const contactType = defineModel<SuggestedContactType>("contactType", {
  default: "influencer",
});

function updateSearchTab(updatedContactType: SuggestedContactType) {
  if (loading) return;

  if (contactType.value === "all") {
    contactType.value =
      updatedContactType === "influencer" ? "outlet" : "influencer";
  } else if (contactType.value !== updatedContactType) {
    contactType.value = "all";
  }
}
</script>
